import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display a country field in the invoice list
 * Uses the embedded country object from the invoice API response
 */
const InvoiceCountryField: React.FC<FieldProps<any>> = ({
    record,
    link = false,
}) => {
    if (!record || !record.country) return null;

    const { country } = record;

    if (!country.id || !country.name)
        return <span>{country.name || 'Unknown'}</span>;

    return link ? (
        <Link to={`/country/${country.id}/show`}>{country.name}</Link>
    ) : (
        <span>{country.name}</span>
    );
};

InvoiceCountryField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

InvoiceCountryField.defaultProps = {
    addLabel: true,
    label: 'Country',
};

export default InvoiceCountryField;
